var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFederatedUser2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Custom/Federated User@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Custom/Federated-User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arch-Category_Customer-Enablement_64"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#658BD3",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9, 3.5725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uE09F",
    transform: "translate(13.6408, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99987526,0.8 L7.99987526,6.4 C7.99987526,6.84225006 7.6416256,7.2 7.19987526,7.2 C6.75812492,7.2 6.39987526,6.84225006 6.39987526,6.4 L6.39987526,2.73250008 L1.36487541,7.76750031 C1.20937538,7.92249985 1.00462532,8 0.799875259,8 C0.595125198,8 0.390375137,7.921875 0.234375,7.765625 C-0.078125,7.453125 -0.078125,6.946875 0.234375,6.634375 L5.26987495,1.6 L1.59987488,1.6 C1.15812492,1.6 0.799874878,1.24250031 0.799874878,0.8 C0.799874878,0.357499695 1.15812492,0 1.59987488,0 L7.19987488,0 C7.64237518,0 7.99987526,0.357499695 7.99987526,0.8 L7.99987526,0.8 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uF007",
    transform: "translate(0, 5.856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7875,8.9 C10.2454301,8.9 12.2375,6.90758212 12.2375,4.45 C12.2375,1.99241788 10.2454301,0 7.7875,0 C5.32957042,0 3.3375,1.99241788 3.3375,4.45 C3.3375,6.90758212 5.32957042,8.9 7.7875,8.9 Z M9.55011761,10.56875 L6.02488292,10.56875 C2.69816018,10.56875 0,13.2665627 0,16.5936324 C0,17.259047 0.539562649,17.7989575 1.20497669,17.7989575 L14.3707193,17.7989575 C15.0361328,17.8 15.575,17.2611328 15.575,16.5936324 C15.575,13.2665627 12.8771873,10.56875 9.55011761,10.56875 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFederatedUser2X);
export default __webpack_public_path__ + "static/media/Federated User@2x.225842041cccf6266e62c9e722d544a5.svg";
export { ForwardRef as ReactComponent };